import React, { Fragment } from "react";
import { Breadcrumb, BreadcrumbProps } from "react-bootstrap";
import { Link } from "react-router-dom";
import { PiCaretRight } from "react-icons/pi";

interface BreadcrumbItem {
  label: string;
  path: string;
}

interface SimpleBreadCrumbProps extends BreadcrumbProps {
  items: BreadcrumbItem[];
}

const SimpleBreadCrumb: React.FC<SimpleBreadCrumbProps> = ({
  items,
  ...props
}) => {
  return (
    <Breadcrumb className="d-flex align-items-center" {...props}>
      {(items ?? []).map((item, index) => (
        <Fragment key={index}>
          <Breadcrumb.Item
            linkAs={Link}
            linkProps={{ to: item.path }}
            className={`text-decoration-none text-muted ${
              index < items.length - 1 && "fw-semibold"
            }`}
          >
            {item.label}
            {index < items.length - 1 && (
              <PiCaretRight className="caret cursor-default" size={20} />
            )}
          </Breadcrumb.Item>
        </Fragment>
      ))}
    </Breadcrumb>
  );
};

export default SimpleBreadCrumb;
